import { IconButton } from "@mui/material";
import { DownloadIcon } from "@primer/octicons-react";
import axios from "axios";
import PropTypes from "prop-types";
import { API_URL } from "utils/constants";
import useAuth from "hooks/useAuth";

const IconDownload = (props) => {
  const { accessToken, user } = useAuth();
  const { filename, name, onError, noMedia, token = true } = props;
  const handleDownload = async () => {
    const stringUrl = API_URL + (noMedia ? "/" : "/media/") + filename;
    const downloadFile = (response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      let download_filename = filename.replace(`${name}_files/`, "");
      link.setAttribute("download", download_filename);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    };
    try {
      // await fetch(stringUrl, {
      //   method: "GET", // or 'POST', 'PUT', etc.
      //   mode: "no-cors",
      //   headers: {
      //     "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      //     "X-CSRF-TOKEN": "CSRF-Token",
      //     Authorization: `Bearer ${accessToken}`,
      //     "Access-Control-Allow-Origin": "*",
      //     "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      //     "Access-Control-Allow-Headers":
      //       "Origin, X-Requested-With, Content-Type, Accept",
      //     "Access-Control-Allow-Credentials": true,
      //   },
      // })
      //   .then((response) => response.blob()) // Convert the response to a blob
      //   .then((blob) => {
      //     downloadFile(blob);
      //   });
      // .then((response) => {
      //   // console.log(response.json());
      //   console.log("Response:", response.data);
      // });

      const response = await axios.get(stringUrl, {
        responseType: "blob",
        // withCredentials: true,
        headers: {
          // crossdomain: "true",
          // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-CSRF-TOKEN": "CSRF-Token",
          Authorization: `Bearer ${accessToken}`,
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Credentials": true,
        },
      });
      if (response?.data) {
        downloadFile(response.data);
      }
    } catch (error) {
      let error_filename = filename.replace(`${name}_files/`, "");
      let message = "File " + error_filename + " không tồn tại!";
      onError?.(message);
      return;
    }
  };
  return (
    <IconButton aria-label="download" onClick={handleDownload}>
      <DownloadIcon />
    </IconButton>
  );
};
IconDownload.propTypes = {
  filename: PropTypes.any,
  name: PropTypes.string,
  onError: PropTypes.func,
  noMedia: PropTypes.bool,
  token: PropTypes.bool,
};
export default IconDownload;
